/* eslint-disable max-len */
export const partners = [
  {
    width: 225,
    logo: '/Images/barometer/unian-logo.png',
    title: 'Головний медіа-партнер',
    text1: 'УНІАН – найстаріше та найбільше інформаційне агентство України, засноване 1993 року, лідер ринку інформаційних послуг в Україні. ',
    text2: 'Вебсайт unian.ua є найпопулярнішим новинним веб-сайтом UA-нету, також компанія володіє найбільшим українським сервісом новинних фото, одним з найпопулярніших телеграм-каналів нашої держави і великою мережею інформаційних сторінок у Фейсбуці.',
    text3: 'YouTube-канал UNIAN входить до топ-5 найпопулярніших українських новинних YouTube-проектів.',
  },
  {
    width: 300,
    logo: '/Images/barometer/raiff-logo.png',
    title: 'Експертний партнер',
    text1: '«Райффайзен Банк» - найбільший іноземний кредитор українського бізнесу та лідер з наданої гуманітарної та благодійної допомоги серед українських банків.',
    text2: 'У Райфі понад 5 500 співробітників пліч-о-пліч щодня працюють, щоб 2,65 мільйона наших клієнтів могли отримати якісне обслуговування, користуватися продуктами і сервісами банку, розвивати бізнес, адже ми #Разом_з_Україною.',
    text3: '«Ти маєш значення» – слоган бренду роботодавця банку, адже люди – це наш головний актив, і ми даємо їм підтримку і визнання, навчаємо та залучаємо до змін.',
  },
  {
    width: 300,
    logo: '/Images/barometer/fora-logo.png',
    title: 'Експертний партнер',
    text1: '«Фора» – це мережа продуктових магазинів поблизу дому, яка успішно працює на ринку України з 2002 року. Мережа налічує понад 340 магазинів у десяти регіонах України.',
    text2: '«Фора» має власні розподільчі центри та виробничі цехи, а також власні торгові марки «Зірковий вибір» і Favore. Розвиває інтернет-магазин fora.ua, а також мобільний застосунок із персоніфікованою програмою лояльності.',
    text3: 'Щодня «Фора» піклується про понад 450 тисяч гостей і дев\'ять тисяч співробітників. Як роботодавець мережа відкрита для всіх, кому важливі стабільний дохід та перспективи розвитку. «Фора» – робота, потрібна людям.',
  },
  {
    width: 300,
    logo: '/Images/barometer/darnytsa-logo.png',
    title: 'Експертний партнер',
    text1: 'Фармацевтична компанія «Дарниця», заснована у 1930 році, є лідером на фармацевтичному ринку України за обсягом продажів лікарських засобів. ',
    text2: 'Успіх компанії базується на лідерстві кожного співробітника на своєму місці. Команда з понад 1200 професіоналів працює над тим, щоб забезпечити людей ліками нового покоління і покращити якість життя та здоров’я. ',
    text3: 'У «Дарниці» приділяють особливу увагу турботі про співробітників та їхні родини, створюючи умови для розвитку та гідної винагороди, що дозволяє компанії регулярно бути в рейтингах найкращих роботодавців України.',
  },
];

export const timingProperties = [
  {
    title: 'Підготовчий етап проведення дослідження',
    period: 'Липень – Вересень 2025',
    planPoints: [
      'Підготовка дослідження',
      'Формування партнерського пулу',
      'Збір запитань для опитувальників',
    ],
  },
  {
    title: 'Старт дослідження',
    period: 'Вересень – Листопад 2025',
    planPoints: [
      'Онлайн-опитування працівників/шукачів і роботодавців',
      'Аналіз результатів',
      'Підготовка аналітичного звіту',
    ],
  },
  {
    title: 'Підведення підсумків «Барометра ринку праці»',
    period: '17 грудня 2025',
    planPoints: [
      'Презентація результатів',
      'Онлайн-конференція з експертами',
      'Публікація звіту та інфографіки',
    ],
  },
];

export const massMediaList = [
  {
    logo: '/Images/barometer/2025/massMediaLogos/nv-logo.png',
    title: 'NV.ua',
    descr: '– про динаміку ринку праці та очікування працівників у 2024-2025 роках',
    link: 'https://biz.nv.ua/ukr/markets/poshuk-novogo-miscya-roboti-zaymaye-v-ukrajinciv-vid-3-do-6-misyaciv-50477357.html',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/interfax-logo.png',
    title: 'Interfax-Україна',
    descr: '– про ключові інсайти дослідження та їх вплив на економіку країни',
    link: 'https://interfax.com.ua/news/general/1042144.html?utm_source=chatgpt.com',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/fru-logo.png',
    title: 'ФРУ',
    descr: '– Федерація роботодавців України — про запрошення до участі в дослідженні від бізнес-обʼєднання',
    link: 'https://fru.ua/ua/media-center/news/fru/zaproshuemo-doluchitisya-do-doslidzhennya-barometr-rinku-pratsi-voennogo-chasu',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/happy-monday-logo.png',
    title: 'Happy Monday',
    descr: '– про зміни в очікуваннях пошукачів та адаптацію компаній до нових умов ринку праці',
    link: 'https://happymonday.ua/ukraintsi-boiatsia-vtratyty-robotu?utm_source=chatgpt.com',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/delo-logo.png',
    title: 'Delo.ua',
    descr: '– про основні виклики для роботодавців та зміни у кар’єрних пріоритетах українців',
    link: 'https://delo.ua/news/kompaniya-grcua-prezentuvala-doslidzennya-barometr-rinku-praci-2024-2025-439900/',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/hurma-logo.png',
    title: 'Hurma.work',
    descr: '– про основні тренди в управлінні персоналом та прогноз на 2025 рік',
    link: 'https://hurma.work/events/prezentacziya-barometru-rinku-praczi-2024-2025/',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/open4business-logo.png',
    title: 'Open4Business',
    descr: '— про презентацію результатів Барометру ринку праці за 2023 рік',
    link: 'https://open4business.com.ua/prezentacziya-rezultativ-doslidzhennya-barometr-rynku-praczi-2023-prognozy-2024/',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/glavred-logo.png',
    title: 'Главред',
    descr: '— про запрошення від команди grc.ua долучитися до опитування',
    link: 'https://glavred.net/ukraine/komanda-grc-ua-zaproshuye-vzyati-uchast-v-opituvanni-barometr-rinku-praci-2023-prognozi-na-2024-rik-10511284.html',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/facty-logo.png',
    title: 'Факти ICTV',
    descr: '— про основні виклики для ринку праці та реакцію кандидатів',
    link: 'https://fakty.com.ua/ua/ukraine/suspilstvo/20240206-shho-vidbuvayetsya-na-rynku-praczi-v-ukrayini-osnovni-tendencziyi-ta-prognozy-na-2024-rik/',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/eba-logo.png',
    title: 'EBA',
    descr: '– Європейська Бізнес Асоціація — про результати дослідження та його значення для бізнес середовища',
    link: 'https://eba.com.ua/kadrovyj-portal-grc-ua-opublikuvav-rezultaty-doslidzhennya-barometr-rynku-pratsi-ukrayiny-2023-prognozy-na-2024/',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/niss-logo.png',
    title: 'NISS',
    descr: '– Національний інститут стратегічних досліджень — про аналітику Барометру у дослідженні диспропорцій освіти й ринку праці',
    link: 'https://niss.gov.ua/doslidzhennya/sotsialna-polityka/osvitno-kvalifikatsiyni-dysproportsiyi-rynku-pratsi-ukrayiny',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/ictv-logo.png',
    title: 'ICTV',
    descr: '— про результати опитування та нові тенденції ринку праці',
    link: 'https://ictv.ua/ua/partners/tendentsiyi-rynku-pratsi-u-2023-ta-prognozy-na-2024-rik/',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/stb-logo.png',
    title: 'СТБ',
    descr: '— про ключові тенденції ринку праці та очікування на наступний рік',
    link: 'https://www.stb.ua/ua/2024/02/06/tendentsiyi-rynku-pratsi-u-2023-ta-prognozy-na-2024-rik/',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/tsn-logo.png',
    title: 'TSN.ua',
    descr: '— про старт всеукраїнського дослідження від GRC.UA',
    link: 'https://tsn.ua/ukrayina/scho-vidbuvayetsya-na-rinku-praci-grc-rozpochala-masshtabne-doslidzhennya-1813729.html',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/unian-logo.png',
    title: 'УНІАН',
    descr: '— про страхи працівників перед звільненням і нестабільністю зайнятості',
    link: 'https://www.unian.ua/economics/other/kozhen-p-yatiy-ukrajinec-bojitsya-vtratiti-robotu-cherez-skorochennya-doslidzhennya-12890676.html',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/finance-logo.png',
    title: 'Finance.ua',
    descr: '— про поширеність скорочень та зменшення заробітних плат у 2024 році',
    link: 'https://news.finance.ua/ua/skorochennya-zarplaty-u-2024-roci-zaznav-kozhen-desyatyy-ukrainec',
  },
  {
    logo: '/Images/barometer/2025/massMediaLogos/oboz-logo.png',
    title: 'Obozrevatel',
    descr: '— про готовність українців працювати за нижчу зарплату та нові настрої на ринку праці',
    link: 'https://www.obozrevatel.com/ukr/ekonomika-glavnaya/economy/nezvichni-tendentsii-na-rinku-pratsi-chi-gotovi-ukraintsi-pratsyuvati-za-menshi-groshi.htm#goog_rewarded',
  },
];

export const previousBarometerList = [
  {
    videoLink: 'https://www.youtube.com/embed/NF_utjPP_gw?si=h_YaF2elAmDqio1V',
    title: 'Барометр ринку праці України 2023. Прогнози на 2024',
    link: 'https://barometr.grc.ua/',
  },
  {
    videoLink: 'https://www.youtube.com/embed/ru43LWEL7eM?si=4vOi1kDRFDytRJW1',
    title: 'Барометр ринку праці України 2024. Прогнози на 2025',
    link: 'https://grc.ua/barometer',
  },
];

export const aboutCompanyProps = [
  {
    top: 0,
    left: '12px',
    icon: 'generator',
    title: 'Talent Generator',
    descr: 'Масове залучення синьокомірцевої аудиторії через рекламу та просування',
  },
  {
    top: 0,
    left: '862px',
    icon: 'speed',
    title: 'Барометр ринку праці',
    descr: 'Аналіз, інсайти, огляди ринку для HR-стратегій',
  },
  {
    top: '332px',
    left: '12px',
    icon: 'web',
    title: 'Сайт GRC.UA',
    descr: 'Вакансії для керівників та досвідчених спеціалістів + платформа для комунікації бренду роботодавця',
  },
  {
    top: '332px',
    left: '862px',
    icon: 'search',
    title: 'Агенція з підбору персоналу',
    descr: 'Персональний підбір складних і топових позицій. Міжнародний підбір з Kestria',
  },
];
